import React from "react";
import {
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { Feather } from "@expo/vector-icons";

interface FilterIconProps {
  filterCount: number;
  onPress: () => void;
}

function FilterIcon({
  filterCount,
  onPress,
}: FilterIconProps): React.JSX.Element {
  const iconSize = Platform.OS === "web" ? 30 : 24; // Adjust icon size for web and mobile

  return (
    <View style={styles.container}>
      <TouchableOpacity
        style={styles.iconButton}
        onPress={onPress}
        hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
      >
        <Feather name="filter" size={iconSize} />
        {filterCount > 0 && (
          <View style={styles.badge}>
            <Text style={styles.badgeText}>
              {filterCount > 9 ? "9+" : filterCount}
            </Text>
          </View>
        )}
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
  },
  iconButton: {
    marginHorizontal: 5,
    position: "relative",
  },
  badge: {
    position: "absolute",
    top: -5,
    right: -10,
    backgroundColor: "#FF3B30",
    borderRadius: 10,
    minWidth: 20,
    height: 20,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 4,
  },
  badgeText: {
    color: "white",
    fontSize: 12,
    fontWeight: "bold",
  },
});

export default FilterIcon;
